import { cn } from "@/lib/cn";

interface Props {
  deadlineAt: number | null;
}

/**
 * Subtle deadline classifier. Returns:
 *   - "Closing" (red whisper) for <= 7 days
 *   - "Soon"    (gold whisper) for <= 30 days
 *   - null      otherwise — caller hides the badge
 * Calm typography only — no boxes, no fills.
 */
export function UrgencyBadge({ deadlineAt }: Props) {
  if (!deadlineAt) return null;
  const msLeft = deadlineAt - Date.now();
  const daysLeft = Math.ceil(msLeft / (24 * 3600 * 1000));
  if (msLeft <= 0) return null;

  let label: string;
  let tone: string;
  if (daysLeft <= 7) {
    label = daysLeft === 1 ? "Closes tomorrow" : `Closes in ${daysLeft} days`;
    tone = "text-red-300/80";
  } else if (daysLeft <= 30) {
    label = `${daysLeft} days left`;
    tone = "text-gold-glow/80";
  } else {
    return (
      <span className="text-[10px] uppercase tracking-[0.18em] text-muted">
        {daysLeft} days left
      </span>
    );
  }

  return (
    <span className={cn("text-[10px] uppercase tracking-[0.18em]", tone)}>{label}</span>
  );
}
